/**
 * @fileoverview POSTWS handler for the "/engagement/async/segment_insights_actual_stats" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { engagementAsyncSegmentInsightsActualStats } from "./constants";
import type {
  PostwsEngagementAsyncSegmentInsightsActualStatsPayload,
  PostwsEngagementAsyncSegmentInsightsActualStatsProps,
} from "./types";
import { isEngagementAsyncSegmentInsightsActualStatsResult } from "./validators";

export const getEngagementAsyncSegmentInsightsActualStats = reactQueryPostWebsocketAdapter(
  engagementAsyncSegmentInsightsActualStats,
  async (
    signal,
    { appGroupId, segmentId, jobToken, ...props }: PostwsEngagementAsyncSegmentInsightsActualStatsProps
  ): Promise<{}> => {
    const payload: PostwsEngagementAsyncSegmentInsightsActualStatsPayload = {
      ...props,
      job_token: jobToken,
      app_group_id: appGroupId,
      segment_id: segmentId,
    };

    return fetch("/engagement/async/segment_insights_actual_stats", "POST", payload, { signal });
  },
  isEngagementAsyncSegmentInsightsActualStatsResult
);
